function clamp(value, min, max) {
  return Math.min(Math.max(value, min), Math.max(min, max));
}

function overlapArea(first, second) {
  const width = Math.max(
    0,
    Math.min(first.x + first.width, second.x + second.width)
      - Math.max(first.x, second.x)
  );
  const height = Math.max(
    0,
    Math.min(first.y + first.height, second.y + second.height)
      - Math.max(first.y, second.y)
  );
  return width * height;
}

export function positionNodeActionCapsule({
  anchorRect,
  capsuleSize,
  bounds,
  obstacles = [],
  gap = 6,
} = {}) {
  if (
    !anchorRect
    || !capsuleSize
    || !bounds
    || ![
      anchorRect.x,
      anchorRect.y,
      anchorRect.width,
      anchorRect.height,
      capsuleSize.width,
      capsuleSize.height,
      bounds.x,
      bounds.y,
      bounds.width,
      bounds.height,
    ].every(Number.isFinite)
  ) {
    return null;
  }

  const width = Math.max(0, capsuleSize.width);
  const height = Math.max(0, capsuleSize.height);
  const minX = bounds.x;
  const minY = bounds.y;
  const maxX = bounds.x + Math.max(0, bounds.width) - width;
  const maxY = bounds.y + Math.max(0, bounds.height) - height;
  const anchorCenter = anchorRect.x + anchorRect.width / 2;
  const viewportCenter = bounds.x + bounds.width / 2;
  const preferredCorner = anchorCenter > viewportCenter ? 'right' : 'left';
  const corners = preferredCorner === 'right'
    ? ['right', 'left']
    : ['left', 'right'];
  const safeObstacles = Array.isArray(obstacles) ? obstacles : [];

  const candidates = ['above', 'below'].flatMap((vertical) => (
    corners.map((corner) => {
      const rawX = corner === 'right'
        ? anchorRect.x + anchorRect.width - width
        : anchorRect.x;
      const rawY = vertical === 'above'
        ? anchorRect.y - height - gap
        : anchorRect.y + anchorRect.height + gap;
      const rect = {
        x: clamp(rawX, minX, maxX),
        y: clamp(rawY, minY, maxY),
        width,
        height,
      };
      return {
        ...rect,
        corner,
        vertical,
        anchorOverlap: overlapArea(rect, anchorRect),
        obstacleOverlap: safeObstacles.reduce(
          (total, obstacle) => total + overlapArea(rect, obstacle),
          0
        ),
        clampDistance: Math.hypot(rect.x - rawX, rect.y - rawY),
      };
    })
  ));

  candidates.sort((first, second) => (
    first.anchorOverlap - second.anchorOverlap
    || first.obstacleOverlap - second.obstacleOverlap
    || (first.vertical === 'above' ? 0 : 1) - (second.vertical === 'above' ? 0 : 1)
    || first.clampDistance - second.clampDistance
    || (first.corner === preferredCorner ? 0 : 1)
      - (second.corner === preferredCorner ? 0 : 1)
  ));

  const best = candidates[0];
  return {
    x: best.x,
    y: best.y,
    corner: best.corner,
    vertical: best.vertical,
  };
}
